import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/big-thumb-youtube-section.webp")